/* Die Vorabend-Uhrzeit je Wochentag (0288) — gelesen aus `GET /einstellungen`
   und `GET /ich`. Eigenes Modul, damit `betriebswerte.ts` sie ohne
   `routen.ts` bekommt. */

/** Die Vorabend-Uhrzeit je Wochentag (0288): nur `'1'`–`'7'`, `HH:MM` oder `null`. */
export function vorabendJeTag(roh: unknown): Record<string, string | null> {
  const je: Record<string, string | null> = {};
  if (!roh || typeof roh !== "object" || Array.isArray(roh)) return je;
  for (const [tag, wert] of Object.entries(roh as Record<string, unknown>)) {
    if (!/^[1-7]$/.test(tag)) continue;
    if (wert === null) je[tag] = null;
    else if (typeof wert === "string" && /^\d{2}:\d{2}/.test(wert)) je[tag] = wert.slice(0, 5);
  }
  return je;
}
